var _ = require('lodash');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="modal-header"> <button type="button"class="close"data-dismiss="modal"><span>&times;</span></button> <h3 class="modal-title"data-bind="text: options.title"></h3> </div> <div class="modal-body"><!-- ko if: _.isObject(options.message) --> <div data-bind="template: options.message"></div><!-- /ko --><!-- ko if: _.isString(options.message) --> <p data-bind="text: options.message"></p><!-- /ko --> </div> <div class="modal-footer clearfix"> <button type="button"class="btn btn-attention text-semibold text-uppercase"data-bind="click: commit"> Ок </button> </div>';
}
return __p;
};
